import * as types from "../../mutation-types";
import { initial_navigation_object_key, initial_pagination } from "./initialState";

export default {
    [types.EMAILS_RESET_PAGINATION]: (state) => {
        const navigationObject = { initial: {...initial_navigation_object_key} }
        state.pagination = { ...initial_pagination, navigationObject }
    },
    [types.EMAILS_SET_GAPI]: (state, gapi) => {
        state.gapi = gapi
    },
    [types.EMAILS_SET_IS_SIGNED_IN]: (state, is_signed_in) => {
        state.is_signed_in = is_signed_in
    },
    [types.EMAILS_SET_LABEL]: (state, label) => {
        state.label = label
    },
    [types.EMAILS_SET_LABELS]: (state, labels) => {
        state.labels = { ...labels }
    },
    [types.EMAILS_SET_MESSAGE]: (state, message) => {
        state.message = { ...message }
    },
    [types.EMAILS_SET_MESSAGES]: (state, messages) => {
        state.messages = [ ...messages ]
    },
    [types.EMAILS_SET_PAGINATION]: (state, pagination) => {
        state.pagination = { ...pagination }
    },
    [types.EMAILS_SET_PROFILE]: (state, profile) => {
        state.profile = { ...profile }
    },
    [types.EMAILS_SET_QUERY]: (state, query) => {
        state.query = query
    },
}